module.exports = __webpack_public_path__ + "static/background-e4d61fd8768e0643a2bc016d4cb1d909.png";